import makeStyles from '@mui/styles/makeStyles';
import { stepSection } from '../ui/styles';

export const createClasses = makeStyles(theme => ({
  section: stepSection(theme),
  // Figma API Key section: 24px between fields.
  credentialsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(3)
  }
}));
